export default __webpack_public_path__ + "static/media/close-modal.6b4d41be.svg";